import * as variables from './variables.js';

import $ from 'jquery';
// NOTE: Colorbox must see jQuery on the window in order to work properly
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import objectFitImages from "object-fit-images";

import './lib/AnimationEasing';

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import CollapsableGroup from './component/CollapsableGroup';
import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';


$(() => {
	new CollapsableGroup();

	const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
	const mainMenu = new MainMenu({
		menu: '#menu',
		menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
		nodeTrigger: '.menu-item-has-children > a',
		styleClass: {
			menuOpen: 'hasMenuOpen',
			nodeOpen: 'isOpen'
		},
		listeners: [
			new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
		]
	});

	/* CSS - Object Fit polyfill */
	if (!(objectFitImages as any).supportsObjectFit) {
		const someImages = document.querySelectorAll('.responsiveImage img');
		for (let i = 0, l = someImages.length; i < l; i++) {
			// let style = window.getComputedStyle(someImages[i]);
			let position = someImages[i].getAttribute('data-position') || 'center';
			let fit = someImages[i].getAttribute('data-fit') || 'cover';
			let style = someImages[i].getAttribute('style') || '';

			someImages[i].setAttribute('style', style + 'font-family: "object-fit: ' + fit + ';object-position: ' + position + ';"');
		}
		objectFitImages(someImages);
	}
});
